import React, { useState, useEffect, useRef } from 'react';
import { Modal } from "../../common";

export default function SalesforceTestDrive({ triggerSelector, adsId, stockNumber, adUrl }) {
    const [open, setOpen] = useState(false);
    const lightningContainerRef = useRef(null);
    const lightningInitialized = useRef(false);

    const handleTrigger = (e) => {
        e.preventDefault();
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
        lightningInitialized.current = false;
    }

    const initializeLightningFlow = () => {
        if (lightningInitialized.current || !lightningContainerRef.current || !window.$Lightning) {
            return;
        }

        lightningInitialized.current = true;

        window.$Lightning.use("runtime_appointmentbooking:lightningOutGuest",
            function() {
                window.$Lightning.createComponent(
                    "lightning:flow",
                    {},
                    lightningContainerRef.current,
                    function(component) {
                        const inputVariables = [
                            { name: "varAutotelexADSid", type: "String", value: String(adsId || '')},
                            { name: "varAutotelexStockNumber", type: "String", value: String(stockNumber || '')},
                            { name: "varAdURL", type: "String", value: String(adUrl || '')}
                        ];
                        component.startFlow("Custom_Inbound_New_Guest_Appointment", inputVariables);
                    }
                );
            },
            'https://wensink.my.site.com/Afspraak'
        );
    };

    useEffect(() => {
        if (triggerSelector) {
            const triggers = document.querySelectorAll(triggerSelector);
            triggers.forEach(trigger => {
                trigger.addEventListener('click', handleTrigger);
            });

            return () => {
                triggers.forEach(trigger => {
                    trigger.removeEventListener('click', handleTrigger);
                });
            };
        }
    }, [triggerSelector]);

    useEffect(() => {
        if (open && !window.$Lightning) {
            const script = document.createElement('script');
            script.src = 'https://wensink.my.site.com/lightning/lightning.out.js';
            script.onload = () => {
                initializeLightningFlow();
            };
            document.head.appendChild(script);
        } else if (open && window.$Lightning) {
            initializeLightningFlow();
        }
    }, [open]);

    return (
        <>
            <style>
                {`
                    .slds-visual-picker_vertical .slds-visual-picker__figure {
                        height: inherit !important;
                    }

                    .runtime_appointmentbookingFlowLocation .slds-visual-picker_vertical {
                        display: inline-flex !important;
                    }
                `}
            </style>
            <Modal
                open={open}
                handleClose={handleClose}
                modalTitle="Proefrit"
                modalBody={
                    <div
                        ref={lightningContainerRef}
                        style={{ minHeight: '400px', width: '100%' }}
                    >
                    </div>
                }
            />
        </>
    );
}
